/* eslint-disable no-mixed-operators */
import * as React from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { IUserProfile } from "../../../Auth/types";
import { confirmDialog, showDialog } from "../../../Dialog/actions";
import Constants from "../../../../core/libraries/Constants";
import Helper from "../../../../core/libraries/Helper";
import { RootState } from "../../../../store/store";
import AdminWrapper from "../../AdminWrapper";
import RbLabel, { LabelSize } from "../../../../bosch-react/components/label/RbLabel";
import { withRouter } from "react-router-dom";
import { IDropdownOption } from "@fluentui/react";
import { getDivisionsList } from "../../../../services/commonServices";
import { IDivision } from "../Division/types";
import { ILowerFirstCaseMetadata } from "../../../AccessMediator/types";
import { IDirectData, IMoveInfo } from "./types";
import LoadingDialog from "../../../../core/components/LoadingDialog";
import { getGroupInfoById } from "../../../../lib/graph";
import { IGroup } from "@microsoft/mgt-react";
import { getDirectDeps } from "../../../../services/idmServices";
import { QueryTypeEnums } from "../../../../services/type";
import { getDocsForMove } from "../../services";
const RetrieveData = React.lazy(() => import('./RetrieveData'));
const ProceedData = React.lazy(() => import('./ProceedData'));

interface MoveReportsProps {
    userProfile: IUserProfile | undefined,
    confirmDialog: typeof confirmDialog,
    showDialog: typeof showDialog,
    history: any,
    match: any,
}

interface IState {
    divisionItems: IDropdownOption[],
    items: ILowerFirstCaseMetadata[] | null,
    moveInfo: IMoveInfo | null,
    directData: IDirectData | null,
}

class MoveReports extends React.Component<MoveReportsProps, IState> {

    // eslint-disable-next-line @typescript-eslint/no-useless-constructor
    constructor(props: MoveReportsProps) {
        super(props);
        this.state = {
            divisionItems: [],
            items: null,
            moveInfo: null,
            directData: null
        }
    }

    async componentDidMount() {
        await this.handleProfileChanged();
    }

    async componentDidUpdate(prevProps: Readonly<MoveReportsProps>, prevState: Readonly<IState>, snapshot?: any) {
        if (prevProps.userProfile !== this.props.userProfile) {
            await this.handleProfileChanged();
        }
    }


    handleProfileChanged = async () => {
        const { userProfile } = this.props;
        if (!!userProfile) {
            if (userProfile.permissions?.isSuperAdmin || userProfile.permissions?.isThesisAdmin || userProfile.permissions?.checkRnDDivisionAdmin?.isAdmin) {
                this.handleIfAnyDefaultData();
                const divCacheData = Helper.getSessionStorageWithExpiry(Constants.SESSION_STORAGE_KEYS.divisionDropdownItems);
                let divisionMasterList: IDropdownOption[] = [];
                if (!!divCacheData) {
                    divisionMasterList = divCacheData as IDropdownOption[];
                }
                else {
                    let response = await getDivisionsList();
                    let divisions: IDivision[] = !!(response.data) && response.data;
                    divisions.forEach((division) => {
                        divisionMasterList.push({
                            key: division.title || "",
                            text: division.longTitle || "",
                        });
                    });
                    divisionMasterList.unshift({ key: "All", text: "--- All ---" });
                }
                !!divisionMasterList && divisionMasterList.length > 0 && this.setState({
                    divisionItems: divisionMasterList.filter(div => div.key !== "All")
                }, () => {
                    const { divisionItems } = this.state;
                    let selections: IDropdownOption[] = [];
                    if (userProfile.permissions?.isSuperAdmin || userProfile.permissions?.isThesisAdmin) {
                        selections = [...divisionItems]
                    }
                    else if (userProfile.permissions?.checkRnDDivisionAdmin?.isAdmin) {
                        selections = [...divisionItems]?.filter(item => item.key === userProfile.permissions?.checkRnDDivisionAdmin?.divisionTitle || item.key === userProfile.permissions?.checkRnDDivisionAdmin?.divisionCode)
                    }
                    else {
                        selections = [];
                    }
                    this.setState({
                        divisionItems: selections,
                    })
                })
            }
            else {
                /* Access Dialog */
                this.props.confirmDialog(
                    Constants.CONFIRMATION_MESSAGE.NO_PERMISSION.TITLE,
                    Constants.CONFIRMATION_MESSAGE.NO_PERMISSION.CONTENT,
                    true,
                    () => {
                        window.location.href = process.env.REACT_APP_HOME!;
                    }
                );
            }
        }
    }

    handleIfAnyDefaultData = () => {
        let parameters: any = this.props.match.params;
        const srcDep = parameters["srcDep"];
        const objectId = parameters["objectId"];

        !!srcDep && !!objectId && this.setState({
            directData: {
                srcDep: srcDep.replace('_', '/'),
                objectId: objectId
            }
        }, async () => {
            const { directData } = this.state
            if (!!directData) {
                this.props.showDialog("Preparing data for you...")
                let groupInfo = await getGroupInfoById(directData.objectId) as IGroup;
                if (!!groupInfo) {
                    const orgResults = await getDirectDeps({
                        identitiesOrOrgNames: [groupInfo.displayName!],
                        queryType: QueryTypeEnums.OrgNames
                    })
                    if (!!orgResults && orgResults.length > 0) {
                        this.setState({
                            moveInfo: {
                                sourceDepartment: directData.srcDep,
                                sourceDivision: "all",
                                targetedDepartment: orgResults[0].orgName,
                                targetedDivision: orgResults[0].division
                            }
                        }, async () => {
                            const documents = await getDocsForMove("all", this.state.moveInfo?.sourceDivision!, this.state.moveInfo?.sourceDepartment!)
                            !!documents && documents.length > 0 && this.setState({ items: documents })
                            this.props.showDialog(false);
                        })
                    }
                    else {
                        this.props.showDialog(false);
                        this.props.confirmDialog("Failed to validate department", "Please try again later", true, () => { window.location.href = process.env.REACT_APP_HOME!; });
                    }
                }
                else {
                    this.props.showDialog(false);
                    this.props.confirmDialog("Failed to get group info", "Please try again later", true, () => { window.location.href = process.env.REACT_APP_HOME!; });
                }
            }
        })
    }

    render() {
        const { items } = this.state
        return !!this.props.userProfile && <AdminWrapper history={this.props.history}>
            <div className="ms-Grid">
                <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm1" />
                    <div className="ms-Grid-col ms-sm10">

                        <div className="ms-Grid-row">
                            <RbLabel className="header-title" size={LabelSize.Large}>Move Reports</RbLabel>&nbsp;
                            <span className="rb-ic rb-ic-info-i-frame" />&nbsp;
                            <RbLabel size={LabelSize.Small}>While moving reports, you should not edit, delete or move them from other pages.</RbLabel>
                        </div>
                        {!!items && items.length > 0 && <ProceedData items={items} moveInfo={this.state.moveInfo} refreshData={this.handleRefreshData} updateProcessData={this.handleDataFromChild} />
                            || <RetrieveData divisionMasterList={this.state.divisionItems} updateRetrievedData={this.handleDataFromChild} directData={this.state.directData} />}
                    </div>
                    <div className="ms-Grid-col ms-sm1" />
                </div>
            </div>
        </AdminWrapper> || <LoadingDialog />;
    }

    handleDataFromChild = (items: ILowerFirstCaseMetadata[] | null, moveInfo: IMoveInfo | null) => {
        this.setState({ items: items, moveInfo: moveInfo });
    };

    handleRefreshData = () => {
        this.setState({
            items: null
        })
    }
}

const mapStateToProps = (state: RootState) => ({
    userProfile: state.auth.userProfile,
});

export default withRouter(connect(mapStateToProps, { confirmDialog, showDialog })(MoveReports));